import {ReactNode, useContext} from "react";
import {FormContext} from "@/components/form/Form.tsx";

export default function FieldObject({name, children}: {name:string, children: ReactNode}) {
    const form = useContext(FormContext)

    function getValue(n: string) {
        return form.getValue(name)?.[n]
    }
    function setValue(n: string, val: any) {
        form.setValue(name, {...(form.getValue(name)??{}), [n]: val})
    }

    function setValues(val: any) {
        form.setValue(name, {...(form.getValue(name)??{}), ...val})
    }

    function getError(n: string) {
        return form.getError(name)?.[n]
    }
    function setError(n: string, error: any) {
        form.setError(name, {...(form.getError(name)??{}), [n]: error})
    }
    function touchField(n: string) {
        console.log(form.getTouchedField(name))
        form.setTouchedField(name, {...(form.getTouchedField(name)??{}), [n]: true})
    }
    function setTouchedField(n: string, value: any) {
        form.setTouchedField(name, {...(form.getTouchedField(name)??{}), [n]: value})
    }
    function getTouchedField(n: string) {
        return form.getTouchedField(name)?.[n] ?? {}
    }
    async function submit() {
        await form.submit()
    }

    function getRootForm() {
        return form.getRootForm()
    }

    const scope: FormContextType = {getValue, setValue, setValues, getError, setError, touchField, setTouchedField, getTouchedField, submit, getRootForm}

    return <FormContext.Provider value={scope}>{children}</FormContext.Provider>

}